import baseInfo, { ztInitInfo } from '@stores/index.js';
// import remInit from '@utils/rem.js';
import shareInit from '@utils/secondaryShare';
import { isDev } from '@utils/env';

function setExposureLog() {
    if (!window.sendBILog) {
        return;
    }

    let pincode = ztInitInfo?.ztConfig?.pincode; // 口令串
    let logInfo = {
        isDev,
        id: 'clk_new',
        event_id: 'clk_new_3_24_3',
        client_source: ztInitInfo.client_source,
        client_type: ztInitInfo.client_type,
        log_from: 'N10799',
        event_classify: 'CC外部页面', //必传，日志分类 由策划提供
        event_position: '通用赛事专题页', //必传，具体位置 由策划提供
        event_type: '曝光',
        main_info: {
            url: window.location.href,
            name: ztInitInfo.ztConfig.name
        },
        other_info: {}
    };

    if (pincode) {
        logInfo.main_info['_id'] = pincode;
    }

    window.sendBILog(logInfo);
}

function calculateNavPos() {
    const pageItems = document.getElementsByClassName('page_item');
    let domArr = [];
    let scrollTopArr = [];
    for (let index = 0; index < pageItems.length; index++) {
        const item = pageItems[index]; // dom
        domArr[index] = item;
        if (item.id) scrollTopArr[item.id] = item.offsetTop;
    }
    baseInfo.setData('pageItemDom', domArr);
    baseInfo.setData('pageItemScrollTop', scrollTopArr);
}

function initLoaded() {
    let loaded = false;
    window.addEventListener('load', () => {
        loaded = true;
        calculateNavPos();
    });
    setTimeout(() => {
        if (!loaded) {
            loaded = true;
            calculateNavPos();
        }
    }, 5000);
}

/**
 * @description: 程序开发环境、QA分支下,设置domain解决活动插件跨域问题
 * @param {*}
 * @return {null}
 */
function setDomain() {
    const exp = /^[a-zA-Z0-9_-]+.dev.cc.163.com/;
    const reg = new RegExp(exp);
    if (reg.test(location.hostname)) {
        document.domain = '163.com';
        console.warn('开发、测试环境配置domain =>163.com');
    }

    baseInfo.setInitedDomain(true);
}

export default function clientInit(log = true) {
    // remInit();
    log && setExposureLog();
    initLoaded();
    shareInit({
        title: [ztInitInfo.shareInfo.title],
        showPic: ztInitInfo.shareInfo.pic,
        desc: ztInitInfo.shareInfo.desc
    });
    setDomain();
}

export { calculateNavPos };
